module.exports = __webpack_public_path__ + "img/hz8.4cdb7002.png";